import React, { useEffect, useState } from 'react';
import axiosInstance from '../utils/axiosInstance';

// Prominent "Notify HOD" entry point for the lecturer dashboard. Shows how
// many of the lecturer's messages have an unread HOD reply, so a response
// doesn't go unnoticed.
export default function NotifyHodButton() {
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const load = () => {
      axiosInstance.get('/admin/hod-notifications/summary')
        .then((res) => { if (!cancelled) setSummary(res.data); })
        .catch(() => {});
    };
    load();
    const timer = setInterval(load, 60000);
    return () => { cancelled = true; clearInterval(timer); };
  }, []);

  const unread = summary?.unread || 0;
  const open = (summary?.pending || 0) + (summary?.inProcess || 0);

  return (
    <a
      href="/lecturer/notify-hod"
      className="group relative flex items-center gap-3 rounded-lg bg-emerald-600 px-4 py-3 text-white shadow-sm transition hover:bg-emerald-700"
    >
      <span className="flex h-10 w-10 items-center justify-center rounded-full bg-white/20">
        <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M15 17h5l-1.4-1.4A2 2 0 0118 14.2V11a6 6 0 10-12 0v3.2a2 2 0 01-.6 1.4L4 17h5m6 0a3 3 0 11-6 0" />
        </svg>
      </span>
      <span className="text-left">
        <span className="block text-sm font-semibold">Notify HOD</span>
        <span className="block text-xs text-emerald-50">
          {open > 0 ? `${open} open message${open === 1 ? '' : 's'}` : 'Send a message to the HOD'}
        </span>
      </span>
      {unread > 0 && (
        <span
          className="absolute -right-2 -top-2 flex h-6 min-w-[24px] items-center justify-center rounded-full bg-rose-500 px-1.5 text-xs font-bold text-white ring-2 ring-white"
          title={`${unread} new repl${unread === 1 ? 'y' : 'ies'}`}
        >
          {unread > 99 ? '99+' : unread}
        </span>
      )}
    </a>
  );
}
